module.exports = ".custom-btn-report {\n  background-color: #fecc00 !important;\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: bold !important;\n  letter-spacing: 0.3px !important;\n  padding: 7px 30px !important;\n}\n\n.btn-responsive {\n  width: 100%;\n}\n\n@media screen and (min-width: 770px) {\n  .btn-responsive {\n    width: 40%;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/work-order/report-full-piece-ot-dialog/report-full-piece-ot-dialog.component.scss
// module id = ./src/app/system/work-order/report-full-piece-ot-dialog/report-full-piece-ot-dialog.component.scss
// module chunks = main